import React from 'react';
import { CheckCircle2Icon, ReceiptTextIcon, XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const individualCosts = ['Planificación', 'Proyecto', 'Efemérides', 'Secuencia', 'Material imprimible', 'Moldes', 'Cuentos'];
const packIncludes = ['Todo incluido', 'Pago único', 'Acceso inmediato', 'Más de 250 recursos'];
export function SavingsComparison() {
  return <section className="bg-slate-900 py-10 text-white sm:py-14 md:py-16" data-id="element-166">
      <div className="container mx-auto px-4 md:px-6" data-id="element-167">
        <div className="mx-auto max-w-4xl text-center" data-id="element-168">
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-yellow-300" data-id="element-169">
            La cuenta que se acumula sin darte cuenta
          </p>
          <h2 className="mt-2 text-3xl font-black tracking-tight sm:text-4xl" data-id="element-170">
            ¿Cuánto gastás durante el año?
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-171">
            Cada recurso suelto parece una compra chica. Pero durante el año se
            multiplican el gasto, las búsquedas y las horas que nadie te
            devuelve.
          </p>
        </div>

        <div className="mx-auto mt-6 grid max-w-5xl gap-3 md:grid-cols-2 md:gap-5" data-id="element-172">
          <div className="rounded-3xl border border-slate-700 bg-slate-800 p-5 text-left" data-id="element-173">
            <div className="flex items-center gap-2 text-pink-300" data-id="element-174">
              <ReceiptTextIcon className="h-5 w-5" data-id="element-175" />
              <h3 className="font-black" data-id="element-176">Comprar recursos sueltos</h3>
            </div>
            <ul className="mt-4 grid grid-cols-2 gap-2" data-id="element-177">
              {individualCosts.map(item => <li key={item} className="flex items-center gap-1.5 text-sm font-semibold text-slate-200" data-id="element-178">
                  <XIcon className="h-3.5 w-3.5 flex-shrink-0 text-pink-400" data-id="element-179" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-5 border-t border-slate-700 pt-4 text-base font-black text-pink-300" data-id="element-180">
              Más compras. Más búsquedas. Más domingos ocupados.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="rounded-3xl border-2 border-yellow-300 bg-yellow-300 p-5 text-left text-slate-900 shadow-xl shadow-yellow-500/10" data-id="element-181">
            <div className="flex items-center gap-2 text-orange-700" data-id="element-182">
              <CheckCircle2Icon className="h-5 w-5" data-id="element-183" />
              <h3 className="font-black" data-id="element-184">Mega Pack</h3>
            </div>
            <p className="mt-3 text-2xl font-black leading-tight" data-id="element-185">
              Una compra inteligente para resolver todo el año.
            </p>
            <ul className="mt-4 grid grid-cols-2 gap-2" data-id="element-186">
              {packIncludes.map(item => <li key={item} className="flex items-center gap-1.5 text-sm font-bold text-slate-800" data-id="element-187">
                  <CheckCircle2Icon className="h-4 w-4 flex-shrink-0 text-green-700" data-id="element-188" />
                  {item}
                </li>)}
            </ul>
            <div className="mt-5 rounded-2xl bg-white/80 p-3 text-sm font-black leading-snug text-orange-700" data-id="element-189">
              Menos gasto disperso. Más tiempo y tranquilidad para vos.
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}